import { render, staticRenderFns } from "./StageLote.vue?vue&type=template&id=81485bd6"
import script from "./StageLote.vue?vue&type=script&lang=js"
export * from "./StageLote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports